import React, { useState } from 'react';
import { Control, Button } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import TextField from './TextField';

const visible = {
  on:  {visible: true, type: "text", icon: faEye},
  off: {visible: false, type: "password", icon: faEyeSlash}
}

const PasswordField = (props) => {
  const { name, label, value, onChange, ...other } = props;
  const [status, setStatus] = useState(visible.off);
  //const passwordField = useRef();

  const handleClickEye = () => {
    //passwordField.current.focus();
    setStatus(status.visible ? visible.off : visible.on)
  }

  return (
    <TextField 
      type={status.type}
      label={label}
      name={name}
      placeholder='●●●●●●'
      pattern=".{4,20}" 
      title="Informe de 4 a 20 caracteres"
      maxLength="20"
      value={value}
      onChange={onChange}
      focus={false}
      //ref={passwordField}
      {...other}
    >
      <Control>
        <Button type="button" outlined onClick={handleClickEye} title="Clique para exibir/ocultar a senha">
          <FontAwesomeIcon icon={status.icon} />
        </Button>
      </Control>
    </TextField>
  )

}

export default PasswordField;
